/*
 * Sale badge format - Allens Swimwear
 * The theme's own scripts can rewrite the sale badge (for example when a colour swatch is
 * clicked) back to 'SALE XX%'. This keeps every sale badge in the 'XX% OFF' format.
 */
(function () {
    if (window.__allensSaleBadgeFormat) return;
    window.__allensSaleBadgeFormat = true;

    var DONE = /^\d{1,3}% OFF$/i;
    var PERCENT = /^[^\d]*?-?\s*(\d{1,3})\s*%\s*$/;

    function fixBadge(el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text || DONE.test(text)) return;
        var match = text.match(PERCENT);
        if (match) el.textContent = match[1] + '% OFF';
    }

    function fixWithin(node) {
        if (!node || node.nodeType !== 1) return;
        if (node.classList.contains('sale-badge')) fixBadge(node);
        node.querySelectorAll('.sale-badge').forEach(fixBadge);
    }

    var pending = [];
    var scheduled = false;

    function flush() {
        scheduled = false;
        var nodes = pending;
        pending = [];
        nodes.forEach(fixWithin);
    }

    function queue(node) {
        pending.push(node);
        if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(flush);
        }
    }

    function start() {
        fixWithin(document.body);
        new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
                if (!target) return;
                var badge = target.closest ? target.closest('.sale-badge') : null;
                if (badge) {
                    queue(badge);
                } else if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) { if (node.nodeType === 1) queue(node); });
                }
            });
        }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
